/*
* @AUTHOR: Mr.Huang
* @DATA: 2020/6/12 10:31 上午
*/
import request from '@/utils/request'

// 获取总报表
export function getReportAll() {
    return request({
        url: '/agent/proxy-user/fAgent/reportAll',
        method: 'get',
    })
}

// 获取月报表
export function getReportByMonth(date) {
    return request({
        url: `/agent/proxy-user/fAgent/reportByMonth?date=${date}`,
        method: 'get',
    })
}

// 获取月报表网点列表
export function getStoreList(params) {
    return request({
        url: '/agent/proxy-user/fAgent/reportByMonth/storeList',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/reportForms.js